export default {
  render() {
    if (typeof window !== 'undefined') return this.$slots.default
  },
}
